
<template>
    <div class="main">
        <el-dialog
            :title="openData.title"
            :visible.sync="openData.state"
            :close-on-click-modal="false"
            width="700px"
            class="dialog_container"
            @close="dialogVisibleClone"
        >
            <div class="dialog_content">
                <el-form
                    :disabled="openData.title == '详情'"
                    label-position="left"
                    label-width="160px"
                    ref="formData"
                    :model="formData"
                    :rules="formDataRules"
                >
                    <el-form-item
                        label="机构："
                        prop="orgId"
                    >
                        <el-select
                            v-model="formData.orgId"
                            placeholder="请选择机构"
                            style="width: 100%"
                            @change="changeOrg"
                        >
                            <el-option
                                v-for="item in orgList"
                                :key="item.id"
                                :label="item.statName"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="任务类型：" prop="taskType">
                         <el-select
                            v-model="formData.taskType"
                            placeholder="请选择任务类型"
                            style="width: 100%"
                        >
                            <el-option
                                v-for="(item,index) in taskList"
                                :key="index"
                                :label="item.label"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="formData.taskType=='1'?'次数：':'时长'" prop="taskCount">
                        <el-input
                            type="text"
                            v-model.trim="formData.taskCount"
                            placeholder="请输入"
                        ></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div
                slot="footer"
                class="dialog-footer dialog-footer-btn"
                v-if="openData.title != '详情'"
            >
                <el-button type="primary" @click="handleSubmit"
                    >确 定</el-button
                >
                <el-button @click="dialogVisibleClone">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    props: ["openData",'orgList'],
    data() {
        return {
            formData: {
                orgId: "1",
                taskType: "",
                taskCount: ""
            },
            formDataRules: {
                // orgId: [
                //     {
                //         required: true,
                //         message: "机构不能不能为空",
                //         trigger: "change"
                //     },
                // ],
                taskType: [
                    {
                        required: true,
                        message: "任务类型不能为空",
                        trigger: "blur",
                    },
                ],
                taskCount: [
                    {
                        required: true,
                        message: "不能为空",
                        trigger: "blur",
                    },
                ]
            },
            taskList: [
                {
                    id:'1',
                    label:'次数'
                },
                 {
                    id:'2',
                    label:'时长'
                }
            ],
        }
    },
    created() {
        this.formData = {
            orgId: "",
            taskType: "",
            taskCount: "",
        }
        if (this.openData.title != "新增") {
            this.getData()
        }
    },
    methods: {
        changeOrg(val){
           this.orgList.forEach((v,i)=>{
             if(v.id===val){
                this.formData.orgName=v.statName
             }
           })
        },
        // 详情获取
        getData() {
            const self = this
            this.$http
                .request({
                    url: "/jjyl/admin/task/config/getById?id="+self.openData.id,
                    method: "get",
                    data: {},
                })
                .then(async (res) => {
                    if (res.code == 200) {
                        let jsonTemp = { ...res.content }
                        self.formData.id= jsonTemp.id
                        self.formData.orgId= jsonTemp.orgId
                        self.formData.orgName= jsonTemp.orgName
                        self.formData.taskType=jsonTemp.taskType
                        self.formData.taskCount=jsonTemp.taskCount
                    } else {
                        this.$message.error(res.message)
                    }
                })
        },
        handleSubmit() {
            console.log(this.openData.title,'this.openData.title')
            let self = this
            this.$refs.formData.validate((valid) => {
                if (valid) {
                    let url = ""
                    let type=''
                    if(this.openData.title == "新增"){
                      url = "/jjyl/admin/task/config/add"
                      type='post'
                    }
                    if(this.openData.title == "编辑"){
                      url = "/jjyl/admin/task/config/update"
                      type='put'
                    }
                     let data = { ...self.formData }
                        this.$http
                            .request({
                                url: url,
                                method: type,
                                data: {
                                    ...data,
                                },
                            })
                            .then((res) => {
                                if (res.code == 200) {
                                    this.$emit("cancleAddress", true)
                                    this.$message.success(res.message)
                                } else {
                                    this.$message.error(res.message)
                                }
                            })
                }
            })
        },
        dialogVisibleClone() {
            this.$emit("cancleAddress", false)
        },
    },
}
</script>
<style lang="less" scoped>
</style>